import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconCreateBlack } from '../../../assets';
import { ContentPageHeader, ExtraHeaderPage } from '../../molecules/page-header/ContentPageHeader';
import { PRODUCT } from '../../../constants/define/translation';

interface FinalTileHeaderProps {
  extraDropdown: any;
  setIsOpenModal: Function;
  dataFinalTiles: any[];
}

export const FinalTileHeader = (props: FinalTileHeaderProps) => {
  const { t } = useTranslation(PRODUCT);
  const { setIsOpenModal, extraDropdown, dataFinalTiles } = props;

  const extra: ExtraHeaderPage[] = [
    {
      key: 1,
      text: t('header.button.create'),
      bgWhite: 'true',
      onClick: () => setIsOpenModal(true),
      icon: <IconCreateBlack />,
    },
  ];

  return (
    <ContentPageHeader
      title={t('title.finalTile')}
      extra={dataFinalTiles.length ? [] : extra}
      extraDropdown={extraDropdown}
    />
  );
};
